export enum ActionTypes {
  EDIT = 'edit',
  DELETE = 'delete',
  DEFAULT = 'default',
}
